import * as growerActions from './growerActions'

import { Card } from '@atd/rui-base.mui.card'
import { CARD_SX } from '../ravenV5Theme'
import { CardActions } from '@atd/rui-base.mui.card-actions'
import { CardHeader } from '@atd/rui-base.mui.card-header'

import AddIcon from '@mui/icons-material/Add'
import { Button } from '@atd/rui-base.mui.button'
import DeleteButton from '../commonComponents/deleteDialogButton'
import EditIcon from '@mui/icons-material/Create'
import GrowerEdit from './groweredit'
import PersonIcon from '@mui/icons-material/Person'
import PropTypes from 'prop-types'
import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

function mapStateToProps(state, ownProps) {
    return {}
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(growerActions, dispatch),
    }
}

// TODO fix actions details -- use class? (Class unused at this point)
class GrowerCard extends React.Component {
    static propTypes = {
        data: PropTypes.object,
        disabled: PropTypes.bool,
    }

    static defaultProps = {
        data: {},
        disabled: false,
    }

    constructor(props) {
        super(props)
        this.state = {
            editDialogOpen: false,
        }
    }

    handleDelete = () => {
        this.props.deleteGrower(this.props.data.id)
    }

    handleAdd = () => {
        this.props.addFarm(this.props.data.id)
    }

    handleEditRequest = () => {
        this.setState({ editDialogOpen: true })
    }
    handleCancel = () => {
        this.setState({
            editDialogOpen: false,
        })
    }
    handleSave = newData => {
        this.props.updateGrower({...newData})
        this.setState({
            editDialogOpen: false,
        })
    }

    render() {
        return (
            <Card
                key={this.props.data.id}
                name={this.props.data.id}
                className="gffCard"
                sx={CARD_SX}
            >
                <CardHeader
                    sx={{ alignItems: 'flex-start' }}
                    title={this.props.data.name}
                    titleTypographyProps={{ style: { fontSize: '15px', lineHeight: 1.2 } }}
                    subheader="Grower"
                    avatar={<PersonIcon htmlColor="#BCBCBC"/>}
                />
                <CardActions className="gffCardActions">
                    <Button variant="text"
                        startIcon={<EditIcon />}
                        onClick={this.handleEditRequest}
                        disabled={this.props.disabled}
                        color="primary"
                        name="openGrowerDialog"><span className="btnLabel">Details</span></Button>
                    <DeleteButton
                        itemType="grower"
                        deleteFunction={this.handleDelete}
                        disabled={this.props.disabled}
                        primary={true}
                        customContent="Are you sure you wish to delete this grower and all of its farms and fields?"
                    />
                    <Button variant="text"
                        startIcon={<AddIcon />}
                        onClick={this.handleAdd}
                        disabled={this.props.disabled}
                        color="primary"
                        name="addFarm"><span className="btnLabel">Add Farm</span></Button>
                    {this.state.editDialogOpen &&
                        <GrowerEdit
                            data={this.props.data}
                            onCancel={this.handleCancel}
                            onSubmit={this.handleSave}
                        />
                    }
                </CardActions>
            </Card>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GrowerCard)
